import configDefault, { IConfig } from './ConfigDefault';

// 本地中转地址
const mockServerUrl: string = `http://127.0.0.1:${configDefault.mockServerPort}`;

// 测试服Server
const serverAddress: string = 'https://test-ap-fund.partner.tencent.com';

/**
 * 开发服配置
 */
const configData: any = {
	...configDefault,
	/**
	 * 显示日志
	 *
	 * @type {boolean}
	 * @memberof ConfigDefault
	 */
	isDisplayLogs: true,

	/** 代理配置 */
	proxyTable: {
		'/api': {
			realService: serverAddress,
			target: `${mockServerUrl}/api`,
			changeOrigin: true,
			pathRewrite: {
				'^/api': '/api'
			}
		}
	}
};

export default configData;
